import { multiFormatDateString, formatDateString } from '../../utils/DateConvertor';
import { NavLink } from 'react-router-dom';

const SeekerDetailsTable = ({ translation, data, isDonor }) => {
  
  const parse_need = ({ need }) => {
    if (need === "anything") {
      return `${translation.anything}`;
    }
    return need
  };
  
  return (

    <div className="grid grid-cols-1 md:grid-cols-2 space-x-3">
      
      <div className="space-y-3 py-4">
        <h2 className="text-2xl font-semibold">{translation.seeker}: {data.seeker.name} ({data.seeker.type}) </h2>
        {/* Responsive Table Container */}
        <div className="overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm">
          <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
            <tbody className="bg-gray-100 dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
              {/* Name */}
              <tr className="hover:bg-green-200 dark:hover:bg-green-900 transition-colors">
                <td className="px-4 py-3 font-medium text-gray-900 dark:text-white whitespace-nowrap">
                  {translation.seeker_details.name}
                </td>
                <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                  {data.seeker.name} ({data.seeker.type}) 
                </td>
              </tr>


              {/* Country */}
              <tr className="hover:bg-green-200 dark:hover:bg-green-900 transition-colors">
                <td className="px-4 py-3 font-medium text-gray-900 dark:text-white whitespace-nowrap">
                  {translation.country}
                </td>
                <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                  {data.seeker.country}
                </td>
              </tr>

              {/* Phone Number */}
              <tr className="hover:bg-green-200 dark:hover:bg-green-900 transition-colors">
                <td className="px-4 py-3 font-medium text-gray-900 dark:text-white whitespace-nowrap">
                  {translation.seeker_details.phone_no}
                </td>
                <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                  {isDonor ? `${data.seeker.phone_number}` : 
                    <div>
                      {translation.seeker_details.only_donor} <NavLink to="/donor-community" className="text-blue-600 hover:underline dark:text-blue-400">{translation.join_now}</NavLink>
                    </div>
                  }
                </td>
              </tr>
              
              {/* Seeker CNIC */}
              <tr className="hover:bg-green-200 dark:hover:bg-green-900 transition-colors">
                <td className="px-4 py-3 font-medium text-gray-900 dark:text-white whitespace-nowrap">
                  {translation.seeker_details.seeker_cnic}
                </td>
                <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                  {isDonor ? `${data.seeker.cnic}` : 
                    <div>
                      {translation.seeker_details.only_donor} <NavLink to="/donor-community" className="text-blue-600 hover:underline dark:text-blue-400">{translation.join_now}</NavLink>
                    </div>
                  }
                </td>
              </tr>
              
              
              
              {/* Created At */}
              <tr className="hover:bg-green-200 dark:hover:bg-green-900 transition-colors">
                <td className="px-4 py-3 font-medium text-gray-900 dark:text-white whitespace-nowrap">
                  {translation.seeker_details.created_at}
                </td>
                <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                  {multiFormatDateString(data.created)}
                </td>
              </tr>
              
              {/* Human Verification */}
              {data?.human_verification > 50 && (
                <tr className="hover:bg-green-200 dark:hover:bg-green-900 transition-colors dark:bg-gray-750">
                  <td className="px-4 py-3 font-medium text-gray-900 dark:text-white whitespace-nowrap">
                    {translation.seeker_details.human_verification}
                  </td>
                  <td className="px-4 py-3 text-gray-700 dark:text-gray-300 flex items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5 text-green-500 mr-2">
                      <path fillRule="evenodd" d="M8.603 3.799A4.49 4.49 0 0 1 12 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 0 1 3.498 1.307 4.491 4.491 0 0 1 1.307 3.497A4.49 4.49 0 0 1 21.75 12a4.49 4.49 0 0 1-1.549 3.397 4.491 4.491 0 0 1-1.307 3.497 4.491 4.491 0 0 1-3.497 1.307A4.49 4.49 0 0 1 12 21.75a4.49 4.49 0 0 1-3.397-1.549 4.49 4.49 0 0 1-3.498-1.306 4.491 4.491 0 0 1-1.307-3.498A4.49 4.49 0 0 1 2.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 0 1 1.307-3.497 4.49 4.49 0 0 1 3.497-1.307Zm7.007 6.387a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clipRule="evenodd" />
                    </svg>
                    {translation.verified}
                  </td>
                </tr>
              )}
              
              
            </tbody>
          </table>
        </div>
      </div>

      <div className="space-y-3 py-4">
        <h2 className="text-2xl font-semibold">{data.seeker.type} {translation.needs}</h2>
        {/* Responsive Table Container */}

        <div className="overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm">
          
          <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
            <tbody className="bg-gray-100 dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
              {/* Need */}
              <tr className="hover:bg-green-200 dark:hover:bg-green-900 transition-colors">
                <td className="px-4 py-3 font-medium text-gray-900 dark:text-white whitespace-nowrap">
                  {translation.seeker_details.need}
                </td>
                <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                  {parse_need({ need: data.need })} ({data.need_type})
                </td>
              </tr>
              
              
              {/* Total Need */}
              <tr className="hover:bg-green-200 dark:hover:bg-green-900 transition-colors">
                <td className="px-4 py-3 font-medium text-gray-900 dark:text-white whitespace-nowrap">
                  {translation.seeker_details.total_need}
                </td>
                <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                  {data.needed_money.toLocaleString('en-PK', {
                    style: 'currency',
                    currency: `${data.currency}`,
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                  })}
                </td>
              </tr>
              
              {/* Total Donated */}
              {data.paid > 0 && (
                <tr className="hover:bg-green-200 dark:hover:bg-green-900 transition-colors">
                  <td className="px-4 py-3 font-medium text-gray-900 dark:text-white whitespace-nowrap">
                    {translation.seeker_details.total_donated}
                  </td>
                  <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                    {data.paid.toLocaleString('en-PK', {
                      style: 'currency',
                      currency: `${data.currency}`,
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0
                    })}
                  </td>
                </tr>
              )}
              
              {/* Remaining */}
              {data.paid > 0 && (
                <tr className="hover:bg-green-200 dark:hover:bg-green-900 transition-colors">
                  <td className="px-4 py-3 font-medium text-gray-900 dark:text-white whitespace-nowrap">
                    {translation.seeker_details.remaining}
                  </td>
                  <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                    {(data.needed_money - data.paid).toLocaleString('en-PK', {
                      style: 'currency',
                      currency: `${data.currency}`,
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0
                    })}
                  </td>
                </tr>
              )}
              
              {/* Need Before */}
              {data.need_type === "onetime" && (
                <tr className="hover:bg-green-200 dark:hover:bg-green-900 transition-colors">
                  <td className="px-4 py-3 font-medium text-gray-900 dark:text-white whitespace-nowrap">
                    {translation.need_before}
                  </td>
                  <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                    {formatDateString(data.need_before)}
                  </td>
                </tr>
              )}
              
              
              {/* Need For */}
              <tr className="hover:bg-green-200 dark:hover:bg-green-900 transition-colors">
                <td className="px-4 py-3 font-medium text-gray-900 dark:text-white whitespace-nowrap">
                  {translation.seeker_details.need_for}
                </td>
                <td className="px-4 py-3 text-gray-700 dark:text-gray-300">
                  {data.need_for}
                </td>
              </tr>

            </tbody>
          </table>
        </div>
      </div>

    </div>
  );
};

export default SeekerDetailsTable